import type { ConsolePageOption, ConsolePageService, Plugin } from '@/plugins'
import { CORE_PLUGIN } from '@/core'
import {
  container,
  injectable,
  instanceCachingFactory,
  registry,
  singleton,
} from 'tsyringe'
import type { App } from 'vue'
import { PLUGIN_CONSOLE_PAGE } from '@/plugins/builtin/BuiltinPluginSymbol'
import MaterialService from './views/Material.vue'

export interface MaterialOption {
  // 关闭客服侧边栏功能
  disabled?: boolean
}

@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<unknown, unknown>>((c) =>
      c.resolve(MaterialPlugin)
    ),
  },
])
@injectable()
export class MaterialPlugin implements Plugin<unknown, unknown> {
  id: string | symbol = ''
  options: unknown
  service: unknown

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(app: App<Element>): void {
    const plugin =
      container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(
        PLUGIN_CONSOLE_PAGE
      )
    plugin.service.addChildRoute({
      path: 'accounts/material/user',
      component: MaterialService,
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialized(app: App<Element>): void {

  }
}
